<div
  class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold border"
  [class]="chipConfig().containerClass"
>
  <span class="h-1.5 w-1.5 rounded-full" [class]="chipConfig().dotClass"></span>
  {{ status() | subscriptionStatusDisplay }}
</div>
